import { CommonRootState, AppThunkDispatch } from "@common/types/common-root-state-type";

import { useEffect, useState } from "react";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { selectorEqualityFn } from "./selector-equality";



export const useAppDispatch = () => useDispatch<AppThunkDispatch>();
// `selectorEqualityFn` is provably identical to lodash `isEqual` for every input
// (see selector-equality.ts) but adds a cheap ref/shallow fast path, avoiding the
// deep walk for the common "fresh wrapper of stable slices" selector pattern.
export const useAppSelector: TypedUseSelectorHook<CommonRootState> = (selector) => useSelector(selector, selectorEqualityFn);

export function useDebounce<T>(value: T, delay?: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay || 500);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}
